<template>
  <div class="container-xxl">
    <titulo-grande texto="Minhas indicações" posicao="left" />

    <div class="alert alert-secondary" role="alert">
      <div class="row">
        <div class="col-md-6 text-break p-3 mb-4 mb-md-1">
          <strong>Link de indicação:</strong>
          {{ meu_link_afiliado }}
        </div>
        <div class="col-md-6 text-end">
          <a :href="link_zap" target="_blank" class="btn btn-sm btn-success mx-3"><i class="bi bi-whatsapp">
              Compartilhar</i></a>
          <button class="btn btn-sm btn-light" @click="copiar()" title="Copiar seu link de afiliado">Copiar link
            <i class="bi bi-copy"></i></button>
        </div>
      </div>
      <div class="row my-4" v-if="totalIndicacoes.total > 0 && auth.type_access < 4">
        <small class="fs-bold"><b>Indicações:</b></small>
        <ul class="list-group list-group-horizontal overflow-auto">
          <li class="list-group-item btn text-nowrap py-1 me-2" :class="index_indicacao == 'all' ? 'active' : ''" @click="listagem_totais('all')">
            Total <br>
            {{ totalIndicacoes.total }}
          </li>
          <template v-for="(indicacoes, indice) in totalIndicacoes.dados" :key="indice">
            <li class="list-group-item btn text-nowrap py-1 me-1" :class="index_indicacao == indice ? 'active' : ''" v-if="indicacoes > 0" @click="listagem_totais(indice)">
              Nivel {{ indice + 1 }} <br>
              {{ indicacoes }}
            </li>
          </template>
        </ul>
      </div>
    </div>

    <div class="alert alert-secondary overflow-auto" role="alert" v-if="lista_sub_eleitores.length > 0">
      <div class="row">
        <ul class="list-group list-group-horizontal">
          <li class="list-group-item btn text-nowrap" @click="listagemUsuarios()">
            Minhas Indicações
          </li>
          <li class="list-group-item btn text-nowrap" v-for="(list, ind) in lista_sub_eleitores" :key="list.id"
            @click="listagemUsuarios(list.id, ind)">
            <i class="bi bi-arrow-down-right"></i>
            {{ list.texto }}
          </li>
        </ul>
      </div>
    </div>

    <TabelaDatatable :dadosData="dadosData" dadosAjax="" :columns="coluna"
      :btnPersonalizado="{ btn: 'secondary', textoBtn: 'Ver indicações' }" @person_row="qtd_indicacao"
      :ativa_placeholder="ativa_placeholder">

    </TabelaDatatable>
  </div>
</template>

<script>
import TituloGrande from '@/components/TituloGrande.vue';
import TabelaDatatable from '@/components/TabelaDatatable.vue';
import { api } from '@/services/api'
import { AuthStore } from '@/stores/Auth';
import { copiar_texto } from '@/assets/js/functions';
import { toastr } from '@/plugins/toast';

export default {
  name: 'MinhasIndicacoes',
  data() {
    return {
      auth: AuthStore(),
      dadosData: '',
      coluna: [
        { data: 'id.', title: 'Cód', width: '5%' },
        { data: 'nome', title: 'Nome', width: '40%' },
        { data: 'acesso', title: 'Acesso', width: '10%' },
        { name: 'acoes', data: 'qtd_indicacoes', title: 'Qtd indicações', width: '10%' },
        { data: 'data_cadastro', title: 'Data Cadastro', width: '10%' },
        { data: 'status', title: 'Status', width: '15%' },
      ],
      lista_sub_eleitores: [],
      totalIndicacoes: {
        dados: [],
        total: 0,
      },
      index_indicacao: null,
      ativa_placeholder: Boolean,
    }
  },
  components: {
    TituloGrande,
    TabelaDatatable,
  },
  computed: {
    meu_link_afiliado: function () {
      return this.$site + '/cadastro/' + this.auth.user.cod + '/#formulario'
    },
    link_zap: function () {
      var txt = `Cadastrese usando meu link em saiadosofaBr: ` + this.meu_link_afiliado;
      return `https://api.whatsapp.com/send?text=` + txt
    },
  },
  methods: {
    async listagemUsuarios(multiplicador = null, remove_array = -1) {
      this.ativa_placeholder = true
      this.index_indicacao = null;
      try {
        if (multiplicador) {
          var url = 'user/minhas_indicacoes/' + multiplicador
          if (remove_array >= 0) {
            // this.lista_sub_eleitores = this.lista_sub_eleitores.filter( value => value < remove_array)
            this.lista_sub_eleitores.splice(remove_array + 1, 1000)
          }
        } else {
          var url = 'user/minhas_indicacoes'
          this.lista_sub_eleitores = [];
        }
        var dadosData = await api.get(url, { Authorization: this.auth.token })

        this.totalIndicacoes = await api.get('user/total_minhas_indicacoes', { Authorization: this.auth.token })

        if (dadosData.status == 200) {
          this.dadosData = dadosData
        }
      } catch (error) {
        toastr.erro('Erro na requisição')
      }

      this.ativa_placeholder = false
    },
    async listagem_totais(retorno) {
      if(this.index_indicacao == retorno){
        return false
      }
      this.ativa_placeholder = true
      this.index_indicacao = retorno
      var dadosData = await api.get('user/total_minhas_indicacoes/'+retorno, { Authorization: this.auth.token })
      
      if (dadosData.status == 200) {
        this.dadosData = dadosData
      }
      this.ativa_placeholder = false
    },
    async copiar() {
      var cp = await copiar_texto(this.meu_link_afiliado)
      if (cp) {
        toastr.sucesso("Link copiado com sucesso.")
      } else {
        toastr.erro("Não foi possivel copiar o link")
      }
    },
    qtd_indicacao(dados) {

      if (dados.cellData > 0) {
        this.listagemUsuarios(dados.rowData.id)
        this.lista_sub_eleitores.push({ 'id': dados.rowData.id, 'texto': dados.rowData.nome })

      } else {
        toastr.alerta(dados.rowData.nome + ' não possui indicações')
      }
    }
  },
  mounted() {
    this.listagemUsuarios()
  },
}
</script>

<style></style>